import React, { useEffect, useState } from "react";
import { Table, Button, Image } from "antd";
import { useNavigate } from "react-router-dom";
import {
  fetchAllPayoutClubAdmin,
  updateTransactionStatus,
} from "../../../service/admin/transactionService";
import BreadcrumbComponent from "../../CssComponents/BreadCrumbComponents";

const PayoutClubAdmin = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);

  const breadcrumbItems = [
    { name: "Dashboard", url: "/superadmin/dashboard" },
    { name: "Club Admin" },
  ];

  useEffect(() => {
    const loadPayments = async () => {
      const data = await fetchAllPayoutClubAdmin();
      setPayments(data);
    };

    loadPayments();
  }, []);

  // Handle status updates and update local state
  const handleStatusUpdate = async (id, status) => {
    try {
      await updateTransactionStatus(id, status); // Firestore update
      setPayments((prev) =>
        prev.map((p) => (p.id === id ? { ...p, status } : p))
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const columns = [
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "User ID",
      dataIndex: "uid",
      key: "uid",
    },
    {
      title: "Item ID",
      dataIndex: "itemId",
      key: "itemId",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (timestamp) => new Date(timestamp).toLocaleString(),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Proof",
      dataIndex: "proofUrls",
      key: "proofUrls",
      render: (urls) => (
        <div className="flex gap-2">
          {urls.map((url, index) => (
            <Image
              preview
              key={index}
              src={url}
              alt={`Proof ${index + 1}`}
              className="!h-20 !w-24 object-cover object-top overflow-hidden rounded"
            />
          ))}
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      render: (_, record) => {
        if (!record.status || record.status === "pending") {
          // Pending → show Accept / Reject
          return (
            <div className="flex gap-2">
              <Button
                type="primary"
                onClick={() => handleStatusUpdate(record.id, "accepted")}
              >
                Accept
              </Button>
              <Button
                type="default"
                onClick={() => handleStatusUpdate(record.id, "rejected")}
              >
                Reject
              </Button>
            </div>
          );
        }

        // Accepted / Rejected → show status + Undo
        return (
          <div className="flex gap-2 items-center">
            <span
              className={`px-2 py-1 rounded ${
                record.status === "accepted"
                  ? "bg-green-200 text-green-800"
                  : "bg-red-200 text-red-800"
              }`}
            >
              {record.status.charAt(0).toUpperCase() + record.status.slice(1)}
            </span>
            <Button
              type="link"
              danger
              onClick={() => handleStatusUpdate(record.id, "pending")}
            >
              Undo
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="p-6 flex flex-col gap-4">
      <BreadcrumbComponent items={breadcrumbItems} />
      <Table
        dataSource={payments}
        columns={columns}
        rowKey="id"
        scroll={{ x: "max-content" }}
        className="shadow-md w-full overflow-auto"
      />
    </div>
  );
};

export default PayoutClubAdmin;
